import { Call } from 'iconsax-reactjs';
import { memo } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { StyledEndCallToggleButton } from './styled';

const EndCallToggleButton = () => {
  const { id: roomId } = useParams<{ id: string }>();

  const navigate = useNavigate();

  const toggleAudio = () => {
    navigate(`/end/${roomId}`);
  };

  return (
    <StyledEndCallToggleButton onClick={toggleAudio}>
      <Call variant="Outline" />
    </StyledEndCallToggleButton>
  );
};

export default memo(EndCallToggleButton);
